import './App.css';
import ApplePay from './components/ApplePay/ApplePay';
import Success from './components/success/Success';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [decryptedData, setDecryptedData] = useState(null);
  const secretKey = "etranzactglobalresourceapplepay";

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedData = urlParams.get("data");

    if (encryptedData) {
      const decodedEncryptedData = decodeURIComponent(encryptedData);
      const bytes = CryptoJS.AES.decrypt(decodedEncryptedData, secretKey);
      const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      setDecryptedData(decrypted);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={
          <div className="button-section">
            {decryptedData ? (
              <Elements stripe={loadStripe("pk_live_51EMKTHLbNZfBtQStVr0BvJiwt7mh7fEZQ6SchfGqlkUK7DZ1O3AygcINYvrbNNAeYA5qiCucDU43wDeF6Ydmy4YL00otnqOPT0", {
                  stripeAccount: decryptedData.merchant.stripe_id,
                })}>
                <ApplePay />
              </Elements>
            ) : (
              <p className='m-0 text-center py-10'>Loading...</p>
            )}
          </div>
        } />
        <Route path="/success" element={<Success />} />
      </Routes>
    </Router>
  );
}

export default App;
